import React from 'react';
import CompanyForm from "./CompanyForm";
import * as PropTypes from "prop-types";

const CompanyNew = props => <CompanyForm onCancel={props.onCancel} onSubmit={props.onSubmit} duringRegistration={true}/>;

CompanyNew.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

export default CompanyNew;



// WEBPACK FOOTER //
// ./src/components/Companies/CompanyNew.js